import __ from "ramda/es/__";
import any from "ramda/es/any";
import compose from "ramda/es/compose";
import includes from "ramda/es/includes";
import lensProp from "ramda/es/lensProp";
import over from "ramda/es/over";
import prepend from "ramda/es/prepend";
import isFunction from "ramda-extension/es/isFunction";
import isNilOrEmpty from "ramda-extension/es/isNilOrEmpty";
import { CALL_API } from '@gef-ui/middleware-api/constants';
import { resolveValue } from '@gef-ui/middleware-api/middleware/utils';
import { errorContentPath, getDelegationCookies, isCannotDelegate } from '../../utils';
const cannotDelegateError = compose(isCannotDelegate, errorContentPath());
export const delegationExceptionError = (errorRoute)=>(res)=>(dispatch, getState, { pushFn })=>{
            if (cannotDelegateError(res)) {
                pushFn({
                    route: errorRoute,
                    dispatch,
                    getState
                });
            }
        };
const expandHeadersWithCookies = (headers)=>{
    const delegationCookie = getDelegationCookies();
    return {
        ...headers,
        ...delegationCookie?.representativeFor ? {
            'Representative-for': delegationCookie.representativeFor
        } : {}
    };
};
const createDelegationHeaders = (callAPI)=>{
    const apiHeaders = callAPI.headers;
    if (isFunction(apiHeaders)) {
        return compose(expandHeadersWithCookies, apiHeaders);
    } else {
        return expandHeadersWithCookies(apiHeaders);
    }
};
const createDelegationActions = (callApi, errorRoute)=>{
    return over(lensProp('onError'), prepend(delegationExceptionError(errorRoute)), callApi.actions);
};
export default (({ errorRoute = '/login/error', excludeEndpoints = [] } = {})=>({ getState })=>(next)=>(action)=>{
                const callAPI = action[CALL_API];
                if (isNilOrEmpty(callAPI) || !isNilOrEmpty(callAPI) && !getDelegationCookies()) {
                    return next(action);
                }
                const endpoint = resolveValue(getState(), callAPI.endpoint);
                if (any(includes(__, endpoint), [
                    ...excludeEndpoints
                ])) {
                    return next(action);
                }
                const newHeaders = createDelegationHeaders(callAPI);
                const newActions = createDelegationActions(callAPI, errorRoute);
                return next({
                    [CALL_API]: {
                        ...callAPI,
                        headers: newHeaders,
                        actions: newActions
                    }
                });
            });
